<ng-container *ngIf="data.length > 0">
  <div>
    <div class="navigation">
      <div (click)="goToPreviousMonth()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M20.5466 22.12L14.44 16L20.5466 9.88L18.6666 8L10.6666 16L18.6666 24L20.5466 22.12Z"
            fill="#026CDF"
          />
        </svg>
      </div>
      <div class="month">
        <span style="display: flex; flex-direction: row; margin-top: 6px">
          <p
            translate="performance.labels.{{ currentMonth.toLowerCase() }}"
          ></p>
          <p>&nbsp; {{ currentYear}}</p>
        </span>
        <p >{{ getSameMonthEventCount(currentMonth) + " " + ('performance.labels.events'|translate)}}</p>
      </div>
      <div id="navigation-right" (click)="goToNextMonth()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M11.4534 22.12L17.56 16L11.4534 9.88L13.3334 8L21.3334 16L13.3334 24L11.4534 22.12Z"
            fill="#026CDF"
          />
        </svg>
      </div>
    </div>

    <div class="hafta-Container">
      <div
        class="hafta"
        *ngFor="let day of isSmallScreen ? daysOfWeek : daysOfWeekLong"
      >
        <span translate="performance.labels.{{ day }}"></span>
      </div>
    </div>

    <div class="days">
      <ng-container *ngFor="let day of monthDays">
        <div
          class="day"
          [matMenuTriggerFor]="menu"
          [ngClass]="{
            'black-background': hasOnSaleEvent(day),
            'menu-open': isMenuOpen && menuDay === day
          }"
          (click)="toggleMenu(day)"
        >
          <div class="day-container">
            <p class="Body-Bold" style="margin: 0">{{ day.day }}</p>
          </div>
          <ng-container *ngIf="getFirstEventByStatus(day.date) as event ">
            <ng-container
            >
              <!--  -->
              <ng-container *ngIf="event.status == 's01_onsale'">
                <div style="height: 100%; width: 100%">
                  <ng-container *ngIf="!isSmallScreen">
                    <mat-basic-chip
                      class="status"
                      translate="performance.labels.onSale"
                    ></mat-basic-chip>
                    <ng-container *ngIf="type === 'group'">
                      <li *ngIf="getEventName(day.date)" class="XSmall-Regular list calendar-text event-name">{{ getEventName(day.date) | translate}}</li>
                      <li *ngIf="getVenueText(day.date)" class="XSmall-Regular list calendar-text venue-name">{{ getVenueText(day.date) | translate}}</li>
                    </ng-container>
                    <ng-container *ngIf="type !== 'group'">
                      <li class="XSmall-Regular list calendar-text">{{ getEventText(day.date) | translate}}</li>
                    </ng-container>
                    <p class="XSmall-Regular list bottom-right">{{ getSameDateEvents(day.date).length > 1? getSameDateEvents(day.date).length + " " + ('performance.labels.events'|translate): (getDateFromEpoch(event.performanceDate) | localizedDate : timeFormat)}}
                      <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        d="M11.4534 22.12L17.56 16L11.4534 9.88L13.3334 8L21.3334 16L13.3334 24L11.4534 22.12Z"
                        fill="#026CDF"
                      />
                    </svg></p>
                  </ng-container>
                  <ng-container *ngIf="isSmallScreen">
                    <div class="point-container">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="5"
                        height="4"
                        viewBox="0 0 5 4"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_13941_5243)">
                          <path
                            d="M2.71403 0.333008C1.79236 0.333008 1.04736 1.07801 1.04736 1.99967C1.04736 2.92134 1.79236 3.66634 2.71403 3.66634C3.6357 3.66634 4.3807 2.92134 4.3807 1.99967C4.3807 1.07801 3.6357 0.333008 2.71403 0.333008Z"
                            fill="#1BAB1E"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_13941_5243">
                            <rect
                              width="4"
                              height="4"
                              fill="white"
                              transform="translate(0.714111)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <!--  -->
              <ng-container *ngIf="event.status != 's01_onsale'">
                <ng-container *ngIf="!isSmallScreen">
                  <div>
                    <ng-container *ngIf="!isSmallScreen">
                      <mat-basic-chip
                        class="status"
                        style="background: var(--Black-Grays-Moonrock, #bfbfbf);"
                      >
                        {{('performance.status.' + event.status) | translate}}
                      </mat-basic-chip>
                      <ng-container *ngIf="type === 'group'">
                        <li
                          *ngIf="getEventName(day.date)"
                          class="XSmall-Regular list calendar-text event-name"
                          style="color: var(--Black-Grays-Moonrock, #bfbfbf)"
                        >
                          {{ getEventName(day.date) | translate}}
                        </li>
                        <li
                          *ngIf="getVenueText(day.date)"
                          class="XSmall-Regular list calendar-text venue-name"
                          style="color: var(--Black-Grays-Moonrock, #bfbfbf)"
                        >
                          {{ getVenueText(day.date) | translate}}
                        </li>
                      </ng-container>
                      <ng-container *ngIf="type !== 'group'">
                        <li
                          class="XSmall-Regular list calendar-text"
                          style="color: var(--Black-Grays-Moonrock, #bfbfbf)"
                        >
                          {{ getEventText(day.date) | translate}}
                        </li>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="isSmallScreen">
                      <li class="list"></li>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngIf="isSmallScreen">
                  <div class="point-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="5"
                      height="4"
                      viewBox="0 0 5 4"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_13961_5320)">
                        <path
                          d="M2.85685 0.333496C1.93519 0.333496 1.19019 1.0785 1.19019 2.00016C1.19019 2.92183 1.93519 3.66683 2.85685 3.66683C3.77852 3.66683 4.52352 2.92183 4.52352 2.00016C4.52352 1.0785 3.77852 0.333496 2.85685 0.333496Z"
                          fill="#BFBFBF"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_13961_5320">
                          <rect
                            width="4"
                            height="4"
                            fill="white"
                            transform="translate(0.856934)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </ng-container>
              </ng-container>
              <!--  -->
            </ng-container>
          </ng-container>
        </div>
        <!-- mat-menu -->
        <mat-menu #menu="matMenu" (closed)="toggleMenu()">
          <div class="mat-menu-header">
            <div style="display: flex; flex-direction: row">
              <p class="small-bold">{{ day.day }}</p>
              &nbsp;
              <p
                class="small-bold"
                translate="performance.labels.{{ day.date.toLocaleString('en-US', { month: 'long' }).toLocaleLowerCase() }}"
              ></p>
              &nbsp;
              <p
                class="small-bold"
                translate="performance.labels.{{
                  daysOfWeekLong[day.date.getUTCDay()]
                }}"
              ></p>
            </div>
            <div style="display: flex; flex-direction: row">
              <div style="margin-top: 2px;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M6.99996 1.1665C4.74246 1.1665 2.91663 2.99234 2.91663 5.24984C2.91663 8.31234 6.99996 12.8332 6.99996 12.8332C6.99996 12.8332 11.0833 8.31234 11.0833 5.24984C11.0833 2.99234 9.25746 1.1665 6.99996 1.1665ZM4.08329 5.24984C4.08329 3.63984 5.38996 2.33317 6.99996 2.33317C8.60996 2.33317 9.91663 3.63984 9.91663 5.24984C9.91663 6.92984 8.23663 9.444 6.99996 11.0132C5.78663 9.45567 4.08329 6.91234 4.08329 5.24984Z"
                    fill="white"
                  />
                  <path
                    d="M6.99996 6.70817C7.80537 6.70817 8.45829 6.05525 8.45829 5.24984C8.45829 4.44442 7.80537 3.7915 6.99996 3.7915C6.19454 3.7915 5.54163 4.44442 5.54163 5.24984C5.54163 6.05525 6.19454 6.70817 6.99996 6.70817Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p class="small-bold">{{ getEventVenueName(day.date) }}</p>
            </div>
          </div>

          <ng-container *ngFor="let eventTwo of data">
            <a
              class="mat-menu-container"
              style="color: black"
              [href]="eventTwo.status !== 's01_onsale' ? null : [
                generateHref(eventTwo.eventCode, eventTwo.performanceCode, currentRegion, currentLang, eventTwo.keyUrlText)
              ]"
              *ngIf="isSameDay(eventTwo, day.date)
              "
            >
              <div class="container-text">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M8.9925 1.5C4.8525 1.5 1.5 4.86 1.5 9C1.5 13.14 4.8525 16.5 8.9925 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 8.9925 1.5ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15ZM9.375 5.25H8.25V9.75L12.1875 12.1125L12.75 11.19L9.375 9.1875V5.25Z"
                      fill="#262626"
                    />
                  </svg>
                  <p
                    class="small-bold"
                    style="{{'color: '+( eventTwo.status === 's01_onsale'? 'var(--Black-Grays-Onyx, #262626); ' : ' var(--Black-Grays-Moonrock, #bfbfbf); ')+
'                      margin-left: 4px;'}}
                    "
                  >
                    {{ getDateFromEpoch(eventTwo.performanceDate) | localizedDate : timeFormat }}
                  </p>
                  <div>
                    <mat-basic-chip
                      *ngIf="eventTwo.status === 's01_onsale'"
                      class="status"
                      style="padding-left: 10px; padding-right: 10px"
                    >{{('performance.status.' + eventTwo.status) | translate}}</mat-basic-chip>
                    <mat-basic-chip
                      *ngIf="eventTwo.status !== 's01_onsale'"
                      class="status"
                      style="padding-left: 10px; padding-right: 10px; background: var(--Black-Grays-Moonrock, #bfbfbf);"
                    >{{('performance.status.' + eventTwo.status) | translate}}</mat-basic-chip>
                  </div>
                </div>
                <p style="{{'color: '+( eventTwo.status === 's01_onsale'? 'var(--Black-Grays-Onyx, #262626); ' : ' var(--Black-Grays-Moonrock, #bfbfbf); ')}}">{{ eventTwo.eventName? eventTwo.eventName:eventName }}</p>
              </div>
              <div class="container-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.29492 16.59L12.8749 12L8.29492 7.41L9.70492 6L15.7049 12L9.70492 18L8.29492 16.59Z"
                    fill="#026CDF"
                  />
                </svg>
              </div>
            </a>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </div>
</ng-container>
